import React from "react";
import { Input, Form } from "antd";
import { Styles } from "../Config/ThemeConfig";

export function InputTextarea({
  label = "",
  name = "",
  required = false,
  validationmsg = "",
  placeholder = "",
  icon = null,
  onclick = undefined,
  onchange = undefined,
  type = "text",
  classname = "",
  disabled = false,
  value = "",
}) {
  const rules = required ? [{ required: true, message: validationmsg }] : [];
  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
      className={`w_100_p ${classname}`}
    >
      <Input.TextArea
        value={value}
        defaultValue={value}
        placeholder={placeholder}
        prefix={icon}
        onChange={onchange}
        onClick={onclick}
        type={type}
        size={Styles.input_size}
        disabled={disabled}
      />
    </Form.Item>
  );
}
